export default {
  "labels": {
    "distraction": "Distração",
    "moreSevereSpeedingLength": "Exc. vel. muito sério",
    "morningSpeedingLength": "Exc. vel. dia",
    "severeSpeedingLength": "Exc. vel. sério",
    "nightSpeedingLength": "Exc. vel. noite",
    "fov": "FOV"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/behavior/behaviorIndicators.js